import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, API } from "../lib/api";

export default function Blog() {
  const { slug } = useParams();
  const [b, setB] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    api.get(`/blogs/${slug}`).then((r) => setB(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <div className="container-page py-24 text-center"><div className="font-display text-3xl">Post not found.</div></div>;
  if (!b) return <div className="container-page py-16 text-sm text-muted-foreground">Loading…</div>;

  return (
    <article className="container-page py-16 max-w-3xl" data-testid={`post-${slug}`}>
      <Link to="/blog" className="text-xs text-muted-foreground uppercase tracking-[0.18em] hover:text-accent">← All posts</Link>
      <div className="text-xs text-muted-foreground uppercase tracking-[0.18em] mt-6">{b.created_at?.slice(0, 10)}</div>
      <h1 className="font-display text-5xl tracking-tight mt-2 text-balance">{b.title}</h1>
      {b.excerpt && <p className="text-lg text-muted-foreground italic mt-4 leading-relaxed">{b.excerpt}</p>}
      {b.cover_image_id && <img src={`${API}/images/${b.cover_image_id}`} alt={b.title} className="w-full rounded-sm border border-border mt-8" />}
      <div className="prose prose-stone max-w-none text-base leading-[1.85] text-foreground whitespace-pre-line mt-8"
           dangerouslySetInnerHTML={{ __html: b.body.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>') }} />
    </article>
  );
}
